import ag from '../../api';
// console.debug("ag:%o", ag);
import storage from '../../storage'
console.debug("storage:%o", storage);

const state = {
    coins: 0,
    loginData: {},
    wxJsInfo: {},
    wxPayInfo: {},
    hbinfo: {},
    detData: {},
    autopay: false,

    webReqType: 0,
    subtitile: '',
    inputTips: '',
    wxLocation: {}
};

// getters
const getters = {
    loginData: state => {
        return state.loginData;
    },
    wxJsInfo: state => {
        return state.wxJsInfo;
    },
    wxPayInfo: state => {
        return state.wxPayInfo;
    },
    coins: state => {
        return state.coins;
    },
    autopay: state => {
        return state.autopay;
    },
    hbinfo: state => {
        return state.hbinfo;
    },
    detData: state => {
        return state.detData;
    },
    webReqType: state => {
        return state.webReqType;
    },
    wxLocation: state => {
        return state.wxLocation;
    }
};

const UPDATE_LOGIN_DATA = "UPDATE_LOGIN_DATA"
const UPDATE_WX_JSINFO = "UPDATE_WX_JSINFO"
const UPDATE_WX_PAYDATA = "UPDATE_WX_PAYDATA"
const UPDATE_COINS = "UPDATE_COINS"
const UDPATE_AUTOPAY = "UDPATE_AUTOPAY"

const UPDATE_HOMEBODY_INFO = "UPDATE_HOMEBODY_INFO"
const UPDATE_DETAIL_DATA = "UPDATE_DETAIL_DATA"
const UPDATE_REQ_TYPE = "UPDATE_REQ_TYPE"
const UPDATE_LOCALTION_DATA = "UPDATE_LOCALTION_DATA"
const CHECKOUT_FAILURE = "CHECKOUT_FAILURE"


// actions
const actions = {
    reqUserLogin ({ commit, state }, param) {
        console.debug("reqJsApiSign> param:%o", param);
        //const loginData = [...state.loginData]
        ag.userLogin(
            param,
            loginData => {
                commit(UPDATE_LOGIN_DATA, { loginData });
                commit(UPDATE_COINS, {coins:loginData.coin}); },
            () => commit(CHECKOUT_FAILURE)
        )
    },

/*
    reqUserLogin({ commit, state }, param) {
        console.debug("reqJsApiSign> param:%o", param);
        ag.userLogin(param, loginData => {
            console.debug("reqUserLogin> loginData:%o", loginData);
            commit(UPDATE_LOGIN_DATA, {loginData});
            commit(UPDATE_COINS, {coins:loginData.coin});
        })


        (
          param,
          () => {
            console.debug("reqUserLogin> loginData:%o", loginData);
            commit(UPDATE_LOGIN_DATA, {loginData});
            commit(UPDATE_COINS, {coins:loginData.coin});
          },
          // 成功操作
          // 失败操作
          () => {let logindata = storage.getData('logindata'); console.debug("reqUserLogin> fail! logindata:%o", logindata); commit(UPDATE_LOGIN_DATA, {loginData:logindata}); commit(UPDATE_COINS, {coins:logindata.coin});}
        )

    },*/
    reqJsApiSign({commit}, param) {
        console.debug("reqJsApiSign> param:%o", param);
        ag.jsapiSign(param, wxJsInfo => {
            console.debug("reqJsApiSign> wxJsInfo:%o", wxJsInfo);
            commit(UPDATE_WX_JSINFO, {wxJsInfo});
        })
    },
    reqWxpayJsapi({commit}, param) {
        console.debug("reqWxpayJsapi> param:%o", param);
        ag.wxpayJsapi(param, wxPayInfo => {
            console.debug("reqWxpayJsapi> wxPayInfo:%o", wxPayInfo);
            commit(UPDATE_WX_PAYDATA, {wxPayInfo});
        })
    },
    updateAutoPay({commit}, param) {
        console.debug("updateAutoPay> param:%o", param);
        commit(UDPATE_AUTOPAY, {autopay: param});
    },

    reqBizcycleDeal({commit}, param) {
        console.debug("reqBizcycleDeal> param:%o", param);
        ag.bizcycleDeal(param, detData => {
            console.debug("reqBizcycleDeal> detData:%o", detData);
            commit(UPDATE_DETAIL_DATA, {detData});
        })
    },
    reqBizcycleNearby({commit}, param) {
        console.debug("reqBizcycleNearby> param:%o", param);
        ag.bizcycleNearby(param, hbinfo => {
            console.debug("reqBizcycleNearby> hbinfo:%o", hbinfo);
            commit(UPDATE_HOMEBODY_INFO, {hbinfo});
        })
    },
    reqCityDeal({commit}, param) {
        console.debug("reqCityDeal> param:%o", param);
        ag.cityDeal(param, detData => {
            console.debug("reqCityDeal> detData:%o", detData);
            commit(UPDATE_DETAIL_DATA, {detData});
        })
    },
    reqComDeal({commit}, param) {
        console.debug("reqComNearby> param:%o", param);
        ag.comDeal(param, detData => {
            console.debug("reqComNearby> detData:%o", detData);
            commit(UPDATE_DETAIL_DATA, {detData});
        })
    },
    reqComNearby({commit}, param) {
        console.debug("reqComNearby> param:%o", param);
        ag.comNearby(param, hbinfo => {
            console.debug("reqComNearby> hbinfo:%o", hbinfo);
            commit(UPDATE_HOMEBODY_INFO, {hbinfo});
        })
    },
    reqDistDeal({commit}, param) {
        console.debug("reqDistDeal> param:%o", param);
        ag.distDeal(param, detData => {
            console.debug("reqDistDeal> detData:%o", detData);
            commit(UPDATE_DETAIL_DATA, {detData});
        })
    },
    reqDistNearby({commit}, param) {
        console.debug("reqDistNearby> param:%o", param);
        ag.distNearby(param, hbinfo => {
            console.debug("reqDistNearby> hbinfo:%o", hbinfo);
            commit(UPDATE_HOMEBODY_INFO, {hbinfo});
        })
    },
    updateReqType({commit}, param) {
        console.debug("updateReqType> param:%o", param);
        commit(UPDATE_REQ_TYPE, {webReqType: param});
    },
    updateReqCoin({commit}, param) {
        console.debug("updateReqCoin> param:%o", param);
        commit(UPDATE_COINS, {coins:param});
    },
    updateLocation({commit}, param) {
        console.debug("updateLocation> param:%o", param);
        commit(UPDATE_LOCALTION_DATA, {wxLocation: param});
    },

    reqNearby({commit}, {webReqType, loginData, wxLocation}) {
        console.debug("reqDistNearby> webReqType:%o, loginData:%o, wxLocation:%o", webReqType, loginData, wxLocation);
        let params = {
            openid: loginData.openid,
            token: loginData.token,
            latitude: wxLocation.latitude,
            longitude: wxLocation.longitude};
        /*0:com, 1:biz, 2:dist, 3:city*/
        if(webReqType === '1'){
            ag.bizcycleNearby(param, hbinfo => {
                console.debug("reqBizcycleNearby> hbinfo:%o", hbinfo);
                commit(UPDATE_HOMEBODY_INFO, {hbinfo});
            })
        }else if(webReqType === '2'){
            ag.distNearby(param, hbinfo => {
                console.debug("reqDistNearby> hbinfo:%o", hbinfo);
                commit(UPDATE_HOMEBODY_INFO, {hbinfo});
            })
        }else{
            ag.comNearby(param, hbinfo => {
                console.debug("reqComNearby> hbinfo:%o", hbinfo);
                commit(UPDATE_HOMEBODY_INFO, {hbinfo});
            })
        }
    },
    reqDeal({commit}, {webReqType, loginData, value}) {
        console.debug("reqDeal> webReqType:%o, loginData:%o value:%s", webReqType, loginData, value);
        /*0:com, 1:biz, 2:dist, 3:city*/
        if(webReqType === '1'){
            let params = {
                openid: loginData.openid,
                token: loginData.token,
                bizcycle: value };
            console.debug("reqDeal>bizcycleDeal params:%o", params);
            ag.bizcycleDeal(params, detData => {
                console.debug("reqBizcycleDeal> detData:%o", detData);
                if(detData.code === 0){
                    commit(UPDATE_DETAIL_DATA, {detData:detData.data});
                }else{
                    commit(UPDATE_HOMEBODY_INFO, {hbinfo:detData.data.guess});
                }
            })
        }else if(webReqType === '2'){
            let params = {
                openid: loginData.openid,
                token: loginData.token,
                district: value };
            console.debug("reqDeal>distDeal params:%o", params);
            ag.distDeal(params, detData => {
                console.debug("reqDistDeal> detData:%o", detData);
                if(detData.code === 0){
                    commit(UPDATE_DETAIL_DATA, {detData:detData.data});
                }else{
                    commit(UPDATE_HOMEBODY_INFO, {hbinfo:detData.data.guess});
                }
            })
        }else if(webReqType === '3'){
            let params = {
                openid: loginData.openid,
                token: loginData.token,
                bizcycle: value };
            console.debug("reqDeal>cityDeal params:%o", params);
            ag.cityDeal(params, detData => {
                console.debug("reqCityDeal> detData:%o", detData);
                if(detData.code === 0){
                    commit(UPDATE_DETAIL_DATA, {detData:detData.data});
                }else{
                    commit(UPDATE_HOMEBODY_INFO, {hbinfo:detData.data.guess});
                }
            })
        }else{
            let params = {
                openid: loginData.openid,
                token: loginData.token,
                community: value };
            console.debug("reqDeal>comDeal params:%o", params);
            ag.comDeal(params, detData => {
                console.debug("reqComNearby> detData:%o", detData);
                if(detData.code === 0){
                    commit(UPDATE_DETAIL_DATA, {detData:detData.data});
                }else{
                    commit(UPDATE_HOMEBODY_INFO, {hbinfo:detData.data.guess});
                }
            })
        }
    }


};

// mutations
const mutations = {

    [UPDATE_LOGIN_DATA](state, {loginData}) {
        console.debug("UPDATE_LOGIN_DATA> loginData:%o", loginData);
        state.loginData = loginData;
        state.coins = loginData.coin;
        storage.setData('logindata', loginData);
    },
    [CHECKOUT_FAILURE](state) {
        console.debug("CHECKOUT_FAILURE");
        let logindata = storage.getData('logindata');
        console.debug("CHECKOUT_FAILURE logindata:%o", logindata);
        state.loginData = logindata;
        state.coins = logindata.coin;
    },
    [UPDATE_WX_JSINFO](state, {wxJsInfo}) {
        console.debug("UPDATE_WX_JSINFO> wxJsInfo:%o", wxJsInfo);
        state.wxJsInfo = wxJsInfo;
    },
    [UPDATE_WX_PAYDATA](state, {wxPayInfo}) {
        console.debug("UPDATE_WX_PAYDATA> wxPayInfo:%o", wxPayInfo);
        state.wxPayInfo = wxPayInfo;
    },
    [UPDATE_COINS](state, {coins}) {
        console.debug("UPDATE_COINS> coins:%o", coins);
        state.coins = coins;
    },
    [UDPATE_AUTOPAY](state, {autopay}) {
        console.debug("UDPATE_AUTOPAY> autopay:%o", autopay);
        state.autopay = autopay;
    },

    [UPDATE_HOMEBODY_INFO](state, {hbinfo}) {
        console.debug("UPDATE_HOMEBODY_INFO> hbinfo:%o", hbinfo);
        state.hbinfo = hbinfo;
    },
    [UPDATE_DETAIL_DATA](state, {detData}) {
        console.debug("UPDATE_DETAIL_DATA> detData:%o", detData);
        state.detData = detData;
        state.coins = detData.coin;
    },
    [UPDATE_REQ_TYPE](state, {webReqType}) {
        console.debug("UPDATE_REQ_TYPE> webReqType:%o", webReqType);
        state.webReqType = webReqType;
    },
    [UPDATE_LOCALTION_DATA](state, {wxLocation}) {
        console.debug("UPDATE_LOCALTION_DATA> wxLocation:%o", wxLocation);
        state.wxLocation = wxLocation;
    }

};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/home.js